"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        Globalize.addCultureInfo("en", {
            messages: {
                Pivot_nthTab: "Move to the nth tab",
            }
        });
        /**
         * The base container for Pivots.
         */
        var PivotBase = /** @class */ (function (_super) {
            __extends(PivotBase, _super);
            function PivotBase() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            PivotBase.prototype.init = function (data, element) {
                var _this = this;
                _super.prototype.init.call(this, data, element);
                this.LayoutWidth = $dyn.ui.tabWidth(this);
                this.LayoutHeight = $dyn.ui.tabHeight(this);
                this.LayoutMinHeight = { minSizeFunction: $dyn.layout.gridLayoutMinHeight, cssClassArgument: "pivot-container" };
                this.activeItemName = $dyn.computed(function () {
                    var itemName = $dyn.value(_this.ActiveItemName);
                    if (!itemName) {
                        var children_1 = $dyn.value(_this.Children);
                        if (children_1 && children_1.length > 0) {
                            itemName = children_1[0].Name;
                        }
                    }
                    return itemName;
                }, function (value) {
                    $dyn.setValue(_this, "ActiveItemName", value);
                });
                if ($dyn.isObservable(this.ActiveItemName)) {
                    this.ActiveItemName.__skipFirstTimeFire = true;
                }
                // Changes in the active tab page are included in the browser history when the presentation looks like a new page is loaded.
                if ($dyn.value(this.IsPageView) &&
                    element && !element.getAttribute("data-dyn-excludeFromHistory") &&
                    !(data.Root instanceof $dyn.controls.Popup) && !(data.Root instanceof $dyn.controls.Dialog)) {
                    $dyn.observe(this.ActiveItemName, function () {
                        $dyn.shell.browserHistory.changePivot(_this);
                    });
                    $dyn.shell.browserHistory.addPivot(this);
                }
                if ($dyn.value(this.Style) === $dyn.ui.TabStyle.vertical && $dyn.value(this.Width) === $dyn.layout.Size.content) {
                    this._partCreatedHandler = function (evt, part) {
                        if (_this.Root.IsActive()) {
                            var partElement = $(part.element);
                            var parent_1 = partElement.closest(".pivot-container");
                            if ($(_this.element).is(parent_1)) {
                                var tabPage = partElement.parents(".pivot-content");
                                $dyn.context(tabPage[0]).animateWidthResize(_this);
                            }
                        }
                    };
                    $(document.body).on($dyn.forms.Events.partCreated, this._partCreatedHandler);
                }
            };
            PivotBase.prototype.dispose = function () {
                if (this._partCreatedHandler) {
                    $(document.body).off($dyn.forms.Events.partCreated, this._partCreatedHandler);
                }
                _super.prototype.dispose.call(this);
            };
            /**
             * Handler for keyDown events
             * @param event The keydown event that occurred.
             */
            PivotBase.prototype.keyDown = function (event) {
                $dyn.util.handleShortcuts(this, event);
            };
            PivotBase.prototype.FocusedItem = function () {
                var e_1, _a;
                var focusedItem;
                var children = $dyn.value(this.Children);
                if (children) {
                    try {
                        for (var children_2 = __values(children), children_2_1 = children_2.next(); !children_2_1.done; children_2_1 = children_2.next()) {
                            var item = children_2_1.value;
                            var headerElement = item.getHeader();
                            if (document.activeElement === headerElement) {
                                focusedItem = item;
                                break;
                            }
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (children_2_1 && !children_2_1.done && (_a = children_2.return)) _a.call(children_2);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                }
                return focusedItem;
            };
            /**
             * Change the current tab to the next/previous tab
             * @param direction Integer offset corresponding to the number of
             * tabs to move (negative for left/previous, positive for right/next).
             * @returns True to stop propagation on the next event, false otherwise.
             */
            PivotBase.prototype.NavigateTab = function (direction) {
                if ($dyn.value(this.ShowHeaders)) {
                    var children_3 = $dyn.value(this.Children);
                    if (children_3) {
                        var activeName = this.activeItemName();
                        var targetTabIdx = this._getTargetTabIndexFromTabName(activeName, direction);
                        if (targetTabIdx !== undefined) {
                            children_3[targetTabIdx].Activate();
                            return true; // return true to stopPropagation on the event
                        }
                    }
                }
                return false;
            };
            PivotBase.prototype.ChangeTabHeaderFocus = function (direction) {
                if ($dyn.value(this.ShowHeaders) && direction) {
                    var focusedItem = this.FocusedItem();
                    if (focusedItem) {
                        var focusedTabName = focusedItem.Name;
                        var targetTabIdx = this._getTargetTabIndexFromTabName(focusedTabName, direction);
                        if (targetTabIdx !== undefined) {
                            var children_4 = $dyn.value(this.Children);
                            if (children_4) {
                                children_4[targetTabIdx].FocusHeader();
                                return true; // return true to stopPropagation on the event
                            }
                        }
                    }
                }
                return false;
            };
            /**
             * Change the current tab to the given index.
             * @param tabIndex Integer corresponding to the index to move to.
             * @returns True if the specified tab was activated, false otherwise.
             */
            PivotBase.prototype.Navigate_nth_TabPage = function (tabIndex) {
                if ($dyn.value(this.ShowHeaders)) {
                    var children_5 = $dyn.value(this.Children);
                    var childCount = children_5.length;
                    if (tabIndex >= 0 && tabIndex < childCount) {
                        var visibleCount = 0;
                        for (var childIndex = 0; childIndex < childCount; childIndex++) {
                            if ($dyn.value(children_5[childIndex].Visible)) {
                                if (visibleCount === tabIndex) {
                                    children_5[childIndex].Activate();
                                    return true;
                                }
                                visibleCount++;
                            }
                        }
                    }
                }
                return false;
            };
            PivotBase.prototype._getNextOrPreviousTabIndex = function (currentTabIndex, direction) {
                var tabIndex;
                var children = $dyn.value(this.Children);
                if (children) {
                    var childCount = children.length;
                    tabIndex = (((currentTabIndex + direction) % childCount) + childCount) % childCount;
                }
                return tabIndex;
            };
            PivotBase.prototype._getCurrentTabIndexFromTabName = function (tabName) {
                var currentTabIndex;
                var children = $dyn.value(this.Children);
                if (children) {
                    for (var activeTabIdx = 0; activeTabIdx < children.length; activeTabIdx++) {
                        if (children[activeTabIdx].Name === tabName) {
                            currentTabIndex = activeTabIdx;
                            break;
                        }
                    }
                }
                return currentTabIndex;
            };
            PivotBase.prototype._getTargetTabIndexFromTabName = function (tabName, direction) {
                var targetTabIndex;
                var children = $dyn.value(this.Children);
                if (children) {
                    var currentTabIndex = this._getCurrentTabIndexFromTabName(tabName);
                    if (currentTabIndex !== undefined) {
                        targetTabIndex = this._getNextOrPreviousTabIndex(currentTabIndex, direction);
                        if (targetTabIndex !== undefined) {
                            // find next/previous visible tab
                            while (!$dyn.value(children[targetTabIndex].Visible)) {
                                targetTabIndex = this._getNextOrPreviousTabIndex(targetTabIndex, direction);
                            }
                        }
                    }
                }
                return targetTabIndex;
            };
            return PivotBase;
        }($dyn.ui.Container));
        controls.PivotBase = PivotBase;
        PivotBase.prototype.ShowHeaders = true;
        PivotBase.prototype.ActiveItemName = "";
        PivotBase.prototype.IsPageView = false;
        PivotBase.prototype.Width = $dyn.layout.Size.available;
        PivotBase.prototype.Height = $dyn.layout.Size.available;
        // tslint:disable:object-literal-sort-keys
        var pivotBaseShortcuts = {
            nthTab: {
                Keys: { alt: true, shift: true, keyCode: $dyn.ui.KeyCodes.numbers },
                Handler: function (evt) {
                    var tabIndex = evt.which - $dyn.ui.KeyCodes.Number1;
                    return this.Navigate_nth_TabPage(tabIndex);
                },
                ShowToUser: function () { return $dyn.value(this.ShowHeaders); },
                Description: $dyn.label("Pivot_nthTab"),
                Category: $dyn.ui.ShortcutCategory.Navigate
            },
        };
        PivotBase.prototype.Shortcuts = $dyn.extendPrototype(PivotBase.prototype.Shortcuts, pivotBaseShortcuts);
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=PivotBase.js.map
